import React, { useEffect } from "react";

interface MapProps {
  origin: { lat: number; lng: number };
  destination?: { lat: number; lng: number };
}

const Map: React.FC<MapProps> = ({ origin, destination }) => {
  useEffect(() => {
    const script = document.createElement("script");
    const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}`;
    script.onload = () => {
      const mapElement = document.getElementById("map");

      if (mapElement) {
        const map = new window.google.maps.Map(mapElement, {
          center: origin,
          zoom: 14,
        });

        // Add a marker for the origin point
        new window.google.maps.Marker({
          position: origin,
          map: map,
          title: "Origin",
        });

        if (destination) {
          const directionsService = new window.google.maps.DirectionsService();
          const directionsRenderer =
            new window.google.maps.DirectionsRenderer();

          const request = {
            origin,
            destination,
            travelMode: window.google.maps.TravelMode.DRIVING,
          };

          directionsService.route(request, (result: any, status) => {
            if (status === "OK") {
              if (result?.routes.length >= 1) {
                directionsRenderer.setDirections(result);
              } else {
                console.error("No routes found.");
              }
            } else {
              console.error("Directions request failed due to", status);
            }
          });

          directionsRenderer.setMap(map);
        }
      }
    };

    document.head.appendChild(script);
  }, [origin, destination]);

  return <div id="map" style={{ height: "500px", width: "100%" }} />;
};

export default Map;
